export function encodeCode(code: Code, word: string): CodeValue {
  return code.values
    .filter(
      cv =>
        cv.value.ja === word ||
        cv.value.en === word ||
        cv.equivalence.includes(word),
    )
    .pop()
}
